import { ResolveFn } from '@angular/router';
import { computed, inject, Signal } from '@angular/core';
import { AppService } from '../../services/app.service';
import { toSignal } from '@angular/core/rxjs-interop';

export const establishmentBreadcrumbResolver: ResolveFn<Signal<string>> = () => {
    const appService = inject(AppService);
    const establishment = toSignal(appService.establishment$);
    return computed(() => establishment()?.name);
};
